/* eslint-disable func-names, no-param-reassign, prefer-spread, no-console, prefer-rest-params */
import React from 'react';
import './logOverlay.css';
const REACT_APP_LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL || 'trace';
const logLevels = ['error', 'warn', 'info', 'debug', 'trace'];
const logColors = [/* '#ff5a5a' */'', /* '#ae7a00' */'', '#1344ff', '#803d80', 'gray'];
// const logStyles = ['background:#ff68681c;', 'background:#ffe00f20;'];

const logLevelShouldOutput = function (logLevel) {
  if (REACT_APP_LOG_LEVEL === 'none') {
    return false;
  }
  return logLevels.indexOf(logLevel) <= logLevels.indexOf(REACT_APP_LOG_LEVEL);
};
const logPrefix = level => {
  const color = logColors[logLevels.indexOf(level)]; // || 'black';
  // const styles = logStyles[logLevels.indexOf(level)] || '';
  const prefix = ["".concat(color ? '%c' : '', "[").concat(level, "]%c ").concat(new Date().toLocaleTimeString().replace(' ', '').toLowerCase())];
  if (color) prefix.push("color:".concat(color, ";"));
  prefix.push('color:gray');
  return prefix;
};
const stringify = obj => {
  try {
    const string = JSON.stringify(obj);
    return string;
  } catch (e) {
    return (obj || '').toString();
  }
};
const formatLogOverlayText = param => {
  const out = typeof param === 'object' ? stringify(param) : (param || '').toString();
  return out /* .substring(0, 100) */ || 'undefined';
};
const extractLineNumberFromStack = function (stack) {
  if (!stack) return '?';
  let line = stack.split('\n')[3];
  if (!line) return '?';
  // A couple misc fixes
  // if (line.indexOf(' (') >= 0) {
  //     const stringSub = line.split(' (')[1];
  //     line = stringSub.substring(0, stringSub.length - 1);
  // } else {
  //     // eslint-disable-next-line prefer-destructuring
  //     line = line.split('at ')[1];
  // }
  line = line.substring(line.indexOf(' at ') + 1);
  const [, origin, path] = line.match(/(.+) \((.+)\)/) || [];
  if (path) {
    const parts = path.split('/');
    if (parts.length > 1) line = "".concat(origin, " (/").concat(parts[parts.length - 1], ")");
  }
  return line;
};
export const logbook = [];
const enjoyLogger = document.getElementById('enjoy-logger');
let logRecordingEnabled = ['production', 'staging'].includes(process.env.NODE_ENV); // Only enable automatically for production & staging, otherwise wait until user activated
let logOverlayEnabled = enjoyLogger && logRecordingEnabled;
let logOverlayActivated = false;
export const oLog = function (logLevel) {
  const e = Error();
  const minTraceLevel = logLevels.indexOf('warn');
  const includeStack = minTraceLevel > -1 && logLevels.indexOf(logLevel) <= minTraceLevel;
  let stack = [];
  if (includeStack) {
    e.stack.split('\n').slice(3).forEach(origin => stack.push(origin.trim().slice(3)));
  } else {
    stack = extractLineNumberFromStack(e.stack);
  }
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  const prefix = (args[0] || '').toString().match(/^(%c)?\[(error|warn|info|debug|trace)\]/) ? [] : logPrefix(logLevel);
  const out = [...prefix, ...args, stack];
  if (logLevelShouldOutput(logLevel) || logOverlayActivated) {
    // eslint-disable-next-line no-nested-ternary
    const cLog = logLevel === 'error' ? console.error : logLevel === 'warn' ? console.warn : console.log;
    if (cLog.apply) cLog.apply(console, out); // Nicer display in some browsers
    else cLog(out);
  }

  // Print to logbook and log overlay if applicable
  const stringifiedArgs = [];
  args.forEach(arg => stringifiedArgs.push(formatLogOverlayText(arg)));
  const outMain = stringifiedArgs.join(',').substring(0, 400);
  const prefixFormatted = ((prefix || [])[0] || '').replace(/%c/g, '');
  const output = (prefixFormatted ? [prefixFormatted] : []).concat([outMain, formatLogOverlayText(stack).substring(0, 500)]).join(' ');
  logbook.push(output);
  // eslint-disable-next-line no-use-before-define
  if (logOverlayEnabled) overlayLogger(output, logLevel);
};
const LogDriver = function () {
  const logger = this;
  this.levels = logLevels;
  const overrides = {};
  if (REACT_APP_LOG_LEVEL !== 'none') {
    if (logLevels.indexOf(REACT_APP_LOG_LEVEL) === -1) {
      throw new Error("Log level '".concat(REACT_APP_LOG_LEVEL, "' does not exist in level list '").concat(JSON.stringify(), "'"));
    }
  }
  logLevels.forEach(level => {
    if (logLevelShouldOutput(level) && !logRecordingEnabled) {
      Object.defineProperty(logger, level, {
        get() {
          if (overrides[level]) return overrides[level];
          // eslint-disable-next-line no-nested-ternary
          const cLog = level === 'error' ? console.error : level === 'warn' ? console.warn : console.log;
          return Function.prototype.bind.call(cLog, console, ...logPrefix(level));
        },
        set(f) {
          overrides[level] = f;
        }
      });
    } else {
      logger[level] = function () {
        for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          params[_key2] = arguments[_key2];
        }
        if (logRecordingEnabled) oLog(level, ...params);
      };
    }
  });
};
const log = new LogDriver();
export default log;
export const LogOverlay = () => /*#__PURE__*/React.createElement("div", {
  id: "enjoy-log-overlay",
  style: {
    display: 'none'
  }
}, /*#__PURE__*/React.createElement("div", null, "Log Output"), /*#__PURE__*/React.createElement("div", {
  className: "enjoy-log-scroll-helper"
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("div", {
  className: "enjoy-log-box"
}, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null)))));
export const initializeLogRecording = () => {
  if (!logRecordingEnabled) {
    logRecordingEnabled = true;
    logLevels.forEach(level => {
      log[level] = function () {
        for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          params[_key3] = arguments[_key3];
        }
        return oLog(level, ...params);
      };
    });
  }
};
export const initializeLogOverlay = () => {
  if (!logOverlayEnabled) {
    logOverlayEnabled = true;
    initializeLogRecording();
  }
};
export const displayLogOverlay = () => {
  logOverlayActivated = true;
  initializeLogOverlay();
  const logContainer = document.querySelector('#enjoy-log-overlay');
  if (logContainer) logContainer.style.display = '';
};
export const hideLogOverlay = () => {
  const logContainer = document.querySelector('#enjoy-log-overlay');
  if (logContainer) logContainer.style.display = 'none';
};
const overlayLogger = (output, logLevel) => {
  const overlay = document.querySelector('#enjoy-log-overlay .enjoy-log-box > div > div > div');
  if (!overlay) return;
  const p = document.createElement('p');
  if (logLevel) p.className = "enjoy-log-".concat(logLevel);
  p.innerText = (output || '').toString();
  overlay.prepend(p);
  if (overlay.childElementCount > 250) {
    overlay.children[overlay.children.length - 1].remove();
  }
};